/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OffenseDetailCheckDto } from './OffenseDetailCheckDto';
import type { OffenseDetailCustomerDto } from './OffenseDetailCustomerDto';
import type { OffenseOrderInfoDto } from './OffenseOrderInfoDto';
export type OffenseDetailDto = {
    /**
     * Offense identifier. Type: "UUID"
     */
    id: string;
    /**
     * Offense variable symbol
     */
    variableSymbol: string;
    /**
     * Offense state
     */
    state: OffenseDetailDto.state;
    /**
     * Offense check
     */
    check: OffenseDetailCheckDto;
    /**
     * Offense customer
     */
    customer: OffenseDetailCustomerDto;
    /**
     * Offense order info
     */
    orderInfo?: OffenseOrderInfoDto;
};
export namespace OffenseDetailDto {
    /**
     * Offense state
     */
    export enum state {
        PENDING = 'PENDING',
        PAID = 'PAID',
        REJECTED = 'REJECTED',
    }
}

